import { render, staticRenderFns } from "./BidFormPreparation.vue?vue&type=template&id=0fb38003&scoped=true"
import script from "./BidFormPreparation.vue?vue&type=script&lang=js"
export * from "./BidFormPreparation.vue?vue&type=script&lang=js"
import style0 from "./BidFormPreparation.vue?vue&type=style&index=0&id=0fb38003&prod&scoped=true&lang=css"
import style1 from "./BidFormPreparation.vue?vue&type=style&index=1&id=0fb38003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb38003",
  null
  
)

export default component.exports